import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className={`
                relative w-14 h-7 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300
                ${theme === 'dark' ? 'bg-slate-700' : 'bg-gray-200'}
            `}
            aria-label="Toggle Theme"
        >
            <div
                className={`
                    w-5 h-5 rounded-full shadow-md flex items-center justify-center transition-transform duration-300 ease-in-out
                    ${theme === 'dark' ? 'bg-slate-800' : 'bg-white'}
                `}
                style={{
                    transform: theme === 'dark' ? 'translateX(28px)' : 'translateX(0)'
                }}
            >
                {theme === 'dark' ? (
                    <Moon size={12} className="text-yellow-400 fill-yellow-400" />
                ) : (
                    <Sun size={12} className="text-orange-500 fill-orange-500" />
                )}
            </div>
        </button>
    );
}
